<template>
    <div class="page-content">
        <!--    页面标题 start -->
        <div v-web-title :data-title="$t('message.orderDetail.title')"></div>
        <!--    页面标题 end -->

        <Row type="flex" justify="center">

            <!--        侧边栏 start -->
            <i-col :lg="4">
                <SideBar class="mobile-no-sidebar" />
            </i-col>
            <!--        侧边栏 end -->

<!--            订单详情内容 start-->
            <i-col :xs="24" :md="24" :lg="12" class-name="right-content">
                <div class="header-block">
                    <div class="title">{{$t('message.orderDetail.headerTitle')}}</div>
                    <div>
                        <Button v-if="order.payment === 1"
                                class="pay-button"
                                type="primary"
                                @click="showPayModal">
                            <span class="header-button">
                                {{$t('message.orderDetail.payButton')}}
                            </span>
                        </Button>
<!--                        <Button-->
<!--                                class="pay-button"-->
<!--                                type="primary"-->
<!--                                @click="showPayModal">-->
<!--                            <span class="header-button">-->
<!--                                {{$t('message.orderDetail.payButton')}}-->
<!--                            </span>-->
<!--                        </Button>-->
                        <Button type="default">
                            <span class="header-button">
                                {{$t('message.orderDetail.cancelButton')}}
                            </span>
                        </Button>
                    </div>
                </div>

                <div class="line line-wrapper"></div>

                <div v-if="!isOrderEmpty">
                    <div class="order-detail-block">
                        <div class="side-item">
                            <div class="title">{{$t('message.orderDetail.roomDetailTitle')}}</div>
                            <div class="item">
                                <div class="name">{{$t('message.orderDetail.roomName')}}:</div>
                                <div class="value">{{order.room_name}}</div>
                            </div>
                            <div class="item">
                                <div class="name">{{$t('message.orderDetail.roomType')}}:</div>
                                <div class="value">{{order.introduce}}</div>
                            </div>
                            <div class="item">
                                <div class="name">{{$t('message.orderDetail.stay')}}:</div>
                                <div class="value">{{stayNights}}</div>
                            </div>
                            <div class="item">
                                <div class="name">{{$t('message.orderDetail.totalMoney')}}:</div>
                                <div class="value price">{{order.currency_type}} {{order.money}}</div>
                            </div>
                            <div class="item">
                                <div class="name">{{$t('message.orderDetail.orderStatus')}}:</div>
                                <div class="value">{{getPaymentStatus(order.payment)}}</div>
                            </div>
                        </div>
                        <div class="col-line"></div>
                        <div class="side-item">
                            <div class="title">{{$t('message.orderDetail.GuestInfo')}}</div>
                            <div class="item">
                                <div class="name">{{$t('message.orderDetail.guestName')}}:</div>
                                <div class="value">{{guestFullName}}</div>
                            </div>
                            <div class="item">
                                <div class="name">{{$t('message.orderDetail.checkin')}}:</div>
                                <div class="value">{{checkinDate}}</div>
                            </div>
                            <div class="item">
                                <div class="name">{{$t('message.orderDetail.checkout')}}:</div>
                                <div class="value">{{checkoutDate}}</div>
                            </div>
                            <div class="item">
                                <div class="name">{{$t('message.orderDetail.phone')}}:</div>
                                <div class="value">{{order.phone}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="line line-wrapper" />

                    <div class="order-des">{{$t('message.orderDetail.orderId')}}: {{order.out_trade_no}}</div>
                    <div class="order-des">{{$t('message.orderDetail.orderInfo')}}: {{order.information}}</div>
                    <div class="order-des">{{$t('message.orderDetail.orderCreateTime')}}: {{order.create_time}}</div>

<!--                    <div class="line line-wrapper"></div>-->

<!--                    <div class="used-coupon-block">-->
<!--                        <div class="title">Used coupon</div>-->
<!--                        <div class="coupon-name">None</div>-->
<!--                    </div>-->
                </div>
                <div v-else class="no-order">
                    No order data...
                </div>


                <div class="line line-wrapper"></div>

                <div class="policy-block">
                    <div class="policy">
                        <div class="title">入住政策</div>
                        <div class="clause">
                            1、按会员等级视酒店餐饮配套情况提供早餐；
                        </div>
                        <div class="clause">
                            2、请于入住日14:00后办理入住，如提前到店，视酒店空房情况安排；
                        </div>
                        <div class="clause">
                            3、会员本人本卡入住，按会员等级可享受早餐、积分、房晚升级和延迟退房等特权（具体参照会员权益）；
                        </div>
                    </div>
                    <div class="policy">
                        <div class="title">取消政策</div>
                        <div class="clause">
                            a、未入住订单，预订3间及以下，入住当日18:00前可免费取消全额退款，逾时取消将扣除所预订房间的全部首晚房费；
                        </div>
                        <div class="clause">
                            b、未入住订单，预订3间以上，入住前一日18:00前可免费取消全额退款，逾时取消将扣除所预订房间的全部首晚房费；
                        </div>
                    </div>
                </div>
            </i-col>
<!--            订单详情内容 end-->

        </Row>

<!--        支付对话框 start -->
        <Modal v-model="isShowPayModal" :mask-closable="false">
            <div slot="header">
                <div class="header-title">{{$t('message.orderDetail.payModal.title')}}</div>
            </div>
            <div class="modal-content">
                <div class="content-top">{{$t('message.orderDetail.payModal.content')}}</div>
                <div>
                    <span class="currency-symbol">{{order.currency_type}}</span>
                    <span class="money">{{order.money}}</span>
                </div>
            </div>
            <div slot="footer" class="footer-block">
                <Button class="pay-button" type="primary"><span class="pay-button-text">{{$t('message.orderDetail.payModal.button')}}</span></Button>
            </div>
        </Modal>
<!--        支付对话框 end -->

    </div>
</template>

<script>
  import SideBar from "../../components/SideBar/SideBar";
  import {empty, getLocalLang, getPaymentStatus, gotoPage, urlRequest} from "../../common/common";
  import moment from 'moment';

  export default {
    name: "OrderDetail",

    data() {
      return {
        // 是否展示支付对话框
        isShowPayModal: false,
        // 订单ID
        orderId: '',
        // 订单数据
        order: {},
        // 入住日期
        checkinDate: '',
        // 离店日期
        checkoutDate: '',
        // 获取本地化支付状态
        getPaymentStatus: getPaymentStatus,
      }
    },

    created() {
      // 前页传来的参数
      console.log('前页传来的参数: ', this.$route.query);
      this.orderId = this.$route.query.orderId;
      console.log('orderId: ', this.orderId)

      // 加载订单数据
      this.loadData();
    },

    methods: {

      // 展示支付对话框
      showPayModal() {
        this.isShowPayModal = true;
      },

      // 加载订单数据
      loadData() {
        if (empty(this.orderId)) {
          // 如果前页没有传来orderId, 则从缓存读取订单数据
          this.order = JSON.parse(localStorage.getItem('order'));
          // 初始化入住和离店日期
          this.checkinDate = moment(this.order.check_in_time).format('YYYY-MM-DD');
          this.checkoutDate = moment(this.order.departure_time).format('YYYY-MM-DD');
        } else {
          // 如果前页有传来orderId，则从接口请求订单数据
          urlRequest({
            url: this.api.getOrder,
            method: 'POST',
            data: {
              'id': this.orderId,
            }
          }).then(res => {
            this.order = res.data.msg[0];
            // 初始化入住和离店日期
            this.checkinDate = moment(this.order.check_in_time).format('YYYY-MM-DD');
            this.checkoutDate = moment(this.order.departure_time).format('YYYY-MM-DD');
          });
        }
      },

      // 跳转到订单列表页面
      gotoOrderList() {
        gotoPage({
          path: '/Order',
        });
      }

    },

    computed: {

      // 订单数据是否为空
      isOrderEmpty() {
        return empty(this.order);
      },

      // 国际化入住晚数
      stayNights() {
        let checkinDateObj = moment(this.checkinDate);
        let checkoutDateObj = moment(this.checkoutDate);
        let lang = getLocalLang();
        let nights = checkoutDateObj.diff(checkinDateObj, 'days');
        if (lang === 'en') {
          if (nights > 1) {
            return nights + ' nights';
          } else {
            return nights + ' night';
          }
        } else {
          return nights + '晚';
        }
      },

      // 客人全名
      guestFullName() {
        return this.order.name + ' ' + this.order.surname;
      }

    },

    components: {
      SideBar,
    }
  }
</script>

<style lang="scss" scoped>
    @import "@/assets/style/mainStyle.scss";
    @import "OrderDetail.scss";

</style>
